// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-container.v-dialog.settings-modal .v-card {\n  height: 90vh;\n}", ""]);
// Exports
module.exports = exports;
